import { Field, ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";


const FormikTextbox: React.FC<FormikTextboxProps> = ({label, isRequired, clasName, fieldName, placeholder, disabled}) => {
  const { t } = useTranslation();
  const requiredText = isRequired ? "*" : "";
  
  return (
    <>
      <label className="form-label">
        {`${t(label)}${requiredText}`}
      </label>

      <Field
        name={fieldName}
        className={`form-control ${clasName}`}
        placeholder={placeholder}
        type="text"
        field={fieldName}
        disabled={disabled}
      />

      <div className="text-danger">
        <ErrorMessage name={fieldName} component="div" />
      </div>
    </>
  )
}

export default FormikTextbox;

type FormikTextboxProps = {
  label: string,
  isRequired?: boolean,
  fieldName: string,
  placeholder?: string,
  clasName?: string,
  disabled?: boolean
}

const defaultProps: Partial<FormikTextboxProps> = {
  isRequired: false,
  placeholder: "",
  clasName: "",
  disabled: false
}

FormikTextbox.defaultProps = defaultProps;
